import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useLoading } from '@/contexts/LoadingContext';

export const RouteTransition: React.FC = () => {
  const location = useLocation();
  const { startLoading, stopLoading } = useLoading();

  useEffect(() => {
    // 只在重要的路由切換時顯示 loading
    const importantRoutes = ['/questionnaire', '/admin', '/result'];
    const isImportantRoute = importantRoutes.some((route) =>
      location.pathname.includes(route),
    );

    if (isImportantRoute) {
      startLoading({ global: true });
      const timer = setTimeout(() => {
        stopLoading({ global: true });
      }, 300);

      return () => {
        clearTimeout(timer);
        stopLoading({ global: true });
      };
    }

    return undefined;
  }, [location.pathname, startLoading, stopLoading]);

  return null;
};
